import { FacebookAuthProvider, getAuth, OAuthProvider, signInWithPopup } from "firebase/auth";
import { IonIcon } from "@ionic/react";
import { logoFacebook } from "ionicons/icons";

import { facebookLogoColor } from "../../../utils/style";

import LoginButton, { Props as ButtonProps } from "./login-button";

export interface Props extends Omit<ButtonProps, "icon" | "text"> {}
export default function FacebookLoginButton({ onLogin, ...props }: Props) {
    const login = async () => {
        const provider = new FacebookAuthProvider();

        provider.addScope("public_profile");
        provider.addScope("email");

        const auth = getAuth();

        try {
            const result = await signInWithPopup(auth, provider);
            const credential = OAuthProvider.credentialFromResult(result);

            if (!credential?.accessToken) {
                throw new Error("NO_TOKEN");
            }

            onLogin?.(null, {
                token: credential.accessToken,
                expiration: Date.now(),
            });
        } catch (err) {
            //-- authentication error, ignore
            console.log(err);
            onLogin?.(err);
        }
    };

    return (
        <LoginButton
            {...props}
            onClick={login}
            text={"Facebook"}
            icon={<IonIcon icon={logoFacebook} style={{ color: facebookLogoColor }} />}
        />
    );
}
